import React, { useState, useEffect, useCallback, Fragment, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isObjectEmpty } from 'common/utils/helpers';
import { getDevicesIds } from 'redux/actions';
import SearchBar from 'components/shared/SearchBar/SearchBar';
import { PerfectScrollbar } from 'components/shared/ReactPerfectScrollbar';
import styles from './ChartExplorerPageSearchBar.module.css';

function ChartExplorerPageSearchBar({ onChange }) {
  const searchBarRef = useRef(null);
  const dispatch = useDispatch();
  const [filteredDevicesIds, setFilteredDevicesIds] = useState([]);
  const [searchBarValue, setSearchBarValue] = useState('');
  const devicesIds = useSelector((store) => store.data.devicesIds);
  const handleChange = useCallback(
    (value) => {
      const searchBar = searchBarRef.current;
      if (searchBar) {
        searchBar.setState({ focused: false, touched: false, value: 'Search' });
      }
      onChange(value);
    },
    [onChange]
  );
  const handleEnter = useCallback(
    (event) => {
      const {
        target: { value }
      } = event;

      if (filteredDevicesIds.includes(value)) {
        event.target.blur();
        handleChange(value);
      }
    },
    [handleChange, filteredDevicesIds]
  );

  useEffect(() => {
    if (isObjectEmpty(devicesIds)) {
      dispatch(getDevicesIds()); // fetch all devices IDs from _search API for chart explorer page search bar
    }
  }, [dispatch, devicesIds]);

  useEffect(() => {
    if (isObjectEmpty(devicesIds)) {
      return;
    }

    const nextDeviceIds =
      searchBarValue.length > 0 ? devicesIds.filter((deviceId) => deviceId.includes(searchBarValue)) : devicesIds;

    setFilteredDevicesIds(nextDeviceIds.slice(0, 50));
  }, [searchBarValue, devicesIds]);

  return (
    <SearchBar
      ref={searchBarRef}
      iconClassName={styles.searchBar}
      searchQuery={(value) => {
        setSearchBarValue(value);
      }}
      defaultText={'Look up other devices'}
      dropdown={<SearchBarDropdown options={filteredDevicesIds} search={searchBarValue} onChange={handleChange} />}
      handleEnter={handleEnter}
    />
  );
}

export default ChartExplorerPageSearchBar;

function SearchBarDropdown({ search, options, onChange }) {
  return (
    <div className={styles.dropdownContainer}>
      <ul className={styles.dropdownUl}>
        <PerfectScrollbar className={styles.dropdownScrollbar}>
          <div className={styles.dropdownHeader}>Devices</div>
          {options.length === 0 ? (
            <li className={styles.dropdownLi}>
              <div className={styles.dropdownString}>No devices match search</div>
            </li>
          ) : (
            options.map((value) => (
              <li key={value} className={styles.dropdownLi} onMouseDown={() => onChange(value)}>
                <HighlightedText text={value} search={search} />
              </li>
            ))
          )}
        </PerfectScrollbar>
      </ul>
    </div>
  );
}

function HighlightedText({ text, search }) {
  const index = text.indexOf(search);
  const str1 = text.substring(0, index);
  const str2 = text.substring(index, index + search.length);
  const str3 = text.substring(index + search.length);

  return (
    <Fragment>
      <div className={styles.dropdownString}>{str1}</div>
      <div className={styles.dropdownStringHighlighted}>{str2}</div>
      <div className={styles.dropdownString}>{str3}</div>
    </Fragment>
  );
}
